import { ErrorNotice } from '@bcecloud/portal-ui';
import { READINESS_ISSUE, type ReadinessIssue } from '../lib/api';
import { Button } from '../ui/button';

export interface ExportIssuesNoticeProps {
  readonly issues: readonly ReadinessIssue[];
  readonly onDismiss: () => void;
}

/**
 * The issues as one readable message: each empty field, then every sample
 * phrase found, named once, with what to do about it.
 */
export function exportIssuesMessage(issues: readonly ReadinessIssue[]): string {
  const missing = issues.filter((issue) => issue.kind === READINESS_ISSUE.missing).map((issue) => issue.message);
  const samples = [...new Set(issues.filter((issue) => issue.kind === READINESS_ISSUE.sample).map((issue) => `"${issue.subject}"`))];
  const sampleSentence =
    samples.length > 0
      ? `It still contains template sample text that is not this deal: ${samples.join(', ')}. Edit that text, or ask the assistant to replace the page with a fresh one from the template.`
      : '';
  return [...missing, sampleSentence].filter((part) => part !== '').join(' ');
}

/**
 * Why the PDF did not open: the proposal still carries template sample text or
 * an empty required field. Shown in place of the export, under the top bar.
 */
export function ExportIssuesNotice({ issues, onDismiss }: ExportIssuesNoticeProps): React.ReactElement {
  return (
    <div className="border-b bg-card px-3 pt-3">
      <ErrorNotice
        inline
        title="This proposal can't be exported yet."
        message={exportIssuesMessage(issues)}
        action={
          <Button variant="secondary" size="sm" onClick={onDismiss}>
            Dismiss
          </Button>
        }
      />
    </div>
  );
}
